import { ReactElement, useEffect, useState } from 'react';
import { useQuery, useQueryClient } from 'react-query';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { GetCustomerInfo } from '../../../services/customer.service';
import Profile from './profile';
import ProfileSkeleton from './profileSkeleton';
import Support from './support';
import UserProfile from './userProfile';
import { IGetCustomerInfoResponse } from '../../../models/customer.model';


const MenuContainer = ({ setTabChild }: { setTabChild: any }) => {
    const [state, setState] = useState<'profile' | 'support' | 'userProfile'>('profile');
    const stateReduxBottomNav = useSelector((state: RootState) => state.loansTabComponents.prevState);
    const stateFromRedux = useSelector((state: RootState) => state.prevAndNextState.nextInnerState) as 'profile' | 'support' | 'userProfile';
    const queryClient = useQueryClient()
    const { profile, isLoading }: { profile: IGetCustomerInfoResponse; isLoading: boolean } = queryClient.getQueryData('PROFILE_INFO')! || {}
    useEffect(() => {
        if (stateFromRedux.includes('profile') || stateReduxBottomNav.includes('profile'))
            setState('profile')
    }, [stateFromRedux, stateReduxBottomNav])

    const menuStatus: Record<'profile' | 'support' | 'userProfile', ReactElement> = {
        profile: <Profile setState={setState} setTabChild={setTabChild} profile={profile!} />,
        support: <Support />,
        userProfile: <UserProfile profile={profile!} />

    }
    if (isLoading) {
        return (
            <ProfileSkeleton />
        )
    }
    return (
        <>
            {menuStatus[state]}
        </>
    )
}

export default MenuContainer